import { parseISO, format } from 'date-fns'
import { de } from 'date-fns/locale'

export function formatDate(isoDate: string, formatter: string = 'd. MMMM yyyy') {
  const date = parseISO(isoDate)

  return format(date, formatter, { locale: de })
}
